const getCSSVariable = (variableName) => {
    return getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
};

export function generateOption3HTML(data) {
    const {
        title,
        author_name,
        category,
        date,
        html,
    } = data;
    const marginLeft = getCSSVariable('--marginLeftDefault')
    const marginRight = getCSSVariable('--marginRightDefault')
    console.log(title, author_name, category, date, html);
    return `
    <style>
    /* General Layout */

    .contentSection{
     margin: 60px ${marginRight} 0px ${marginLeft};
        height: 100%;
    }
.content-wrapper {
    display: flex;
    flex-direction: row;
    gap: 20px;
    align-items: stretch; /* <-- stretch child heights */
    height: 100%; /* make sure this has height */
}

.text-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 100%; /* fill the parent's height */
}

    /* Text Block */
    .text-title {
        margin:0px 0px 5px 0px;
    }

    .text-meta {
        display: flex;
        justify-content: space-between;
        margin-bottom: 0px;
        gap:10px;
        flex-wrap: wrap;
        /* Allow wrapping of text content */
    }

    .text-meta p {
        margin: 0;
    }
    .textHeader {
  flex-shrink: 0; /* don't shrink */
  /* Optionally: add margin-bottom or border for separation */
  margin-bottom:10px;
}
    .text-paragraph {
        flex:1
        text-align: justify;
        margin-top: 10px;
    }

    .cat {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    /* Media Query for Small Screens */
    @media screen and (max-width: 900px) {
        .content-wrapper {
            flex-direction: column-reverse;
            /* Reverse the order to place text above image */
        }

            .text-content {
    width: 100%;
    }

        .text-paragraph {
            margin-top: 10px;
        }
    }

    @media screen and (max-width: 500px) {
        .cat {
            width: 100%;
            /* Force the second paragraph to take the full width */
            order: 3;
        }
        .text-meta {
            flex-direction: row;
            /* Ensure that they are in a row even on small screens */
            justify-content: space-between;
            align-items: center;
        }
    }
</style>

<div class="contentSection">
    <div class="content-wrapper">
        <div class="text-content">
            <div class="textHeader">
                <h1 class="text-title">${title}</h1>
                <div class="text-meta">
                    <p class="meta-first">${author_name}</p>
                    <div class="cat">
                        <p class="meta-second">${category}</p>
                    </div>
                    <p class="meta-first">${new Date(date).toLocaleDateString('de-DE', {
        day: '2-digit', month: 'short', year: 'numeric'
    })}</p>
                </div>
            </div>
            <div class="text-paragraph">${html}</div>
        </div>
    </div>
</div>
`;
}
